// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3esl-","controls":"styles_controls__Kq6er","charLimit":"styles_charLimit__1JkP4","input":"styles_input__3nnc6","send":"styles_send__rNpyZ"};